/**
 * Removes any service worker and cache left behind by the old build, which
 * served the site from a precache. The worker at `service-worker.js` retires
 * itself when it is next checked for updates; this covers the browsers where a
 * registration or its caches linger after that.
 */
export function retireServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;

  void navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) void registration.unregister();
  });

  if (!('caches' in window)) return;
  void caches.keys().then((keys) => {
    for (const key of keys) void caches.delete(key);
  });
}
